import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { PartCategory } from '../../../opc-app/partcategory/partcategory.model';
import { ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/api';
import { NotificationService } from '../../../shared/services/notification.service';
import { OPCConstant } from '../../../opc-app/opc.const';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PartCategoryService } from '../../../shared/services/partcategory.service';
import { OPCSettings } from '../../../shared/models/opcsettings.model';

@Component({
    selector: 'app-partcategory-item',
    templateUrl: './partcategory-item.component.html'
})
export class PartCategoryItemComponent implements OnInit {
    @Input() partCategory: PartCategory;
    @Input() i: string;
    @Output() isSubmited: EventEmitter<any> = new EventEmitter();
    @Output() isDeleted: EventEmitter<any> = new EventEmitter();
    @ViewChild('fileUpload')
    fileUpload: any;
    clonePartCategory: PartCategory;
    file: any;
    notifications: Message[] = [];
    pcName: string;
    pcFormGroup: FormGroup;
    pcDescField: FormControl;
    showImage: boolean;
    partCategoryImgPath: string;
    opcSettings: OPCSettings = new OPCSettings();
    allPartCategories: any;
    indexOrderID: FormControl;
    addIndex: boolean;
    

    constructor(private _partCategoryService: PartCategoryService,
        private confirmationService: ConfirmationService, private notifyService: NotificationService) {
    }

  ngOnInit(): void {
    this.addIndex = this._partCategoryService.addIndex;
        this.clonePartCategory = Object.assign({}, this.partCategory);
        this.pcName = this.partCategory.partCategoryDesc ? this.partCategory.partCategoryDesc : '';
        this.showImage = false;
        this.formControlValidation();
    this.formGroupValidation();
    }
    formControlValidation() {
        this.pcDescField = new FormControl('', [
            Validators.required,
            Validators.maxLength(60),
            Validators.minLength(3)
        ]);
      this.indexOrderID = new FormControl('');
    }
    formGroupValidation() {
        this.pcFormGroup = new FormGroup({
          pcDescField: this.pcDescField,
          indexOrderID: this.indexOrderID
        });
    }
  getAllPartCategories() {
    this._partCategoryService.getAllPartCategories().subscribe((res) => {
      this.allPartCategories = res;
    })
    }
    onUpload(event) {
        const fileBrowser = this.fileUpload.nativeElement;
        if (fileBrowser.files && fileBrowser.files[0]) {
            this.file = fileBrowser.files[0];
        }
        if (!(this.file.size > this.opcSettings.minImageSize
            && this.file.size < this.opcSettings.maxImageSize
            && this.file.type === this.opcSettings.validImageFormat)) {
            this.notifications = this.notifyService.growlNotification('warn', OPCConstant.INVALID_IMAGE_UPLOAD);
            event.srcElement.value = '';
            this.file = undefined;
        }
    }
    onShowImage() {
        this.showImage = true;
    }
    onSubmit() {
        if (this.pcFormGroup.valid) {
            if (!this.pcName) {
                this._partCategoryService.addOrUpdatePartCategory(this.partCategory, this.file, true).subscribe((res: PartCategory) => {
                  this.isSubmited.emit(res);
                  this.ngOnInit();
                },
                    error => {
                        this.notifications = this.notifyService.growlNotification('fail', OPCConstant.ADDED_FAILURE);
                        this.isSubmited.emit(undefined);
                    }
                );
            } else {
                this._partCategoryService.addOrUpdatePartCategory(this.partCategory, this.file, false).subscribe((res: PartCategory) => {
                  this.isSubmited.emit(res);
                  this.ngOnInit();

                },
                    error => {
                        this.notifications = this.notifyService.growlNotification('fail', OPCConstant.UPDATE_FAILURE);
                        this.isSubmited.emit(undefined);
                    }
                );
            }
        } else {
            this.notifications = this.notifyService.growlNotification('warn', OPCConstant.UPDATE_WARNING);
        }
    }
    onExpand() {
        // TO DO
    }
    onDelete(item: number, index: string) {
        if (item) {
            this.confirmationService.confirm({
                header: 'Delete Confirmation',
                key: index,
                message: OPCConstant.CONFIRM_MESSAGE,
                accept: () => {
                    this._partCategoryService.deletePartCategory(item).subscribe(
                        res => {
                            this.isDeleted.emit(true);
                        },
                        error => {
                            this.isDeleted.emit(false);
                            this.notifications = this.notifyService.growlNotification('fail', OPCConstant.PC_DELETE_FAILURE);
                        }
                    );
                }
            });
        } else {
            this.isDeleted.emit(true);
        }
    }
    onReset() {
        this.partCategory = Object.assign({}, this.clonePartCategory);
        this.fileUpload.nativeElement.value = '';
        this.file = undefined;
        if (!this.partCategory.partCategoryID) {
            this.pcFormGroup.reset();
        }
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/partcategory/partcategory-item/partcategory-item.component.ts